import React, { useEffect, useContext } from "react";
import MyContext from "../../../context/MyContext";

const EditableText = ({ value, inputRef, EditorZoom }) => {
  const {
    LayersData,
    setLayersData,
    calculateWidthByDuration,
    calculateTimeByWidth,
    onePxEquivalent,
    CanvasDisplay,
    setisTextInputOrAreaFocus,
  } = useContext(MyContext);

  function isHTML(str) {
    var a = document.createElement("div");
    a.innerHTML = str;
    for (var c = a.childNodes, i = c.length; i--; ) {
      if (c[i].nodeType == 1 && c[i].tagName.toLowerCase() != "br") return true;
    }
    return false;
  }

  const msToTime = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };
  useEffect(() => {
    if (isHTML(value.text)) {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === value.key) {
          var a = document.createElement("div");
          a.innerHTML = value.text;
          array[i].text = a.firstChild.innerHTML;
         
        }
      }
      setLayersData(array);
    }
  }, [value.text]);

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };
  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const updateText = () => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === value.key) {
        array[i].text = inputRef.current.innerHTML;
        //Deselect text updating in original Fix
        array[i].originalText = inputRef.current.innerHTML;
        let text = inputRef.current.offsetParent;
        //doing this to call layer data useeffect in myresize
        array[i].isFontButtonClick = true;
        let types = array[i].InEffect;

        if (types == "TypeWriterr") {
          var txt = array[i].text;
          var speed = 50;
          for (let j = 0; j < txt.length; j++) {
            if (
              txt.charAt(j) == "<" &&
              txt.charAt(j + 1).toLowerCase() == "b" &&
              txt.charAt(j + 2).toLowerCase() == "r" &&
              txt.charAt(j + 3).toLowerCase() == ">"
            ) {
              speed = speed + 50;
              j = j + 4;
            } else if (
              txt.charAt(j) == "&" &&
              txt.charAt(j + 1).toLowerCase() == "n" &&
              txt.charAt(j + 2).toLowerCase() == "b" &&
              txt.charAt(j + 3).toLowerCase() == "s" &&
              txt.charAt(j + 4).toLowerCase() == "p" &&
              txt.charAt(j + 5).toLowerCase() == ";"
            ) {
              speed = speed + 50;
              j = j + 6;
            } else {
              speed = speed + 50;
            }
          }
          array[i].startTransitionWidth = calculateWidthByDuration(
            msToTime(speed)
          );
        } else if (
          types == "animated TextBounce " ||
          types == "animated Rolling " ||
          types == "animated TypeWriter "
        ) {
          var txt = array[i].text;
          let charactersArray = [];
          let cleanCharacterArray = [];
          let character = "";
          let calculatedTime = 0;

          for (let j = 0; j < txt.length; j++) {
            if (
              txt.charAt(j) == "<" &&
              txt.charAt(j + 1).toLowerCase() == "b" &&
              txt.charAt(j + 2).toLowerCase() == "r" &&
              txt.charAt(j + 3).toLowerCase() == ">"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                character: character,
                next: "<br>",
                startAt: calculatedTime,
              };
              if (character != "") {
                calculatedTime += 40;
                cleanCharacterArray.push(obj);
              }
              charactersArray.push(obj);
              character = "";
              j = j + 3;
            } else if (
              txt.charAt(j) == "&" &&
              txt.charAt(j + 1).toLowerCase() == "n" &&
              txt.charAt(j + 2).toLowerCase() == "b" &&
              txt.charAt(j + 3).toLowerCase() == "s" &&
              txt.charAt(j + 4).toLowerCase() == "p" &&
              txt.charAt(j + 5).toLowerCase() == ";"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                character: character,
                next: "&nbsp;",
                startAt: calculatedTime,
              };
              if (character != "") {
                calculatedTime += 40;
                cleanCharacterArray.push(obj);
              }
              charactersArray.push(obj);
              character = "";
              j = j + 5;
            } else if (txt.charAt(j) == " ") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                character: character,
                next: " ",
                startAt: calculatedTime,
              };
              if (character != "") {
                calculatedTime += 40;
                cleanCharacterArray.push(obj);
              }
              charactersArray.push(obj);
              character = "";
              // j = j + 6;
            } else {
              if (character != "") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  character: character,
                  next: "",
                  startAt: calculatedTime,
                };
                if (character != "") {
                  calculatedTime += 40;
                  cleanCharacterArray.push(obj);
                }
                charactersArray.push(obj);
              }
              character = txt.charAt(j);
            }
          }

          if (character != "") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              character: character,
              next: "",
              startAt: calculatedTime,
            };
            if (character != "") {
              calculatedTime += 40;
              cleanCharacterArray.push(obj);
            }
            charactersArray.push(obj);
          }
          array[i].CharactersArray = charactersArray;
          array[i].cleanCharacterArray = cleanCharacterArray;

          array[i].startTransitionWidth = calculateWidthByDuration(
            msToTime(calculatedTime)
          );
          let minMsPrLetter =
            totalTimeToMs(calculateTimeByWidth(array[i].startTransitionWidth)) /
            cleanCharacterArray.length;
          //console.log(array[i]);
          if (
            array[i].startTransitionWidth >
            array[i].widthOnTimeline - array[i].endTransitionWidth
          ) {
            minMsPrLetter =
              totalTimeToMs(
                calculateTimeByWidth(
                  array[i].widthOnTimeline - array[i].endTransitionWidth
                )
              ) / cleanCharacterArray.length;
            array[i].startTransitionWidth =
              array[i].widthOnTimeline - array[i].endTransitionWidth; //calculateWidthByDuration(msToTime(calculatedTime));
          }
          array[i].bounceInMs = minMsPrLetter;
          if (minMsPrLetter < 20) {
            alert("can not set transition: " + minMsPrLetter);
          }
        } else if (types == "animated WordByWordFade ") {
          var txt = array[i].text;
          let wordsArray = [];
          let cleanWordsArray = [];
          let word = "";
          let CalculatedTime = 0;
          let opacityIncrement = 0.03;
          let perWordFPS = 60;
          let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
          let perWordMS = 200;

          for (let j = 0; j < txt.length; j++) {
            if (
              txt.charAt(j) == "<" &&
              txt.charAt(j + 1).toLowerCase() == "b" &&
              txt.charAt(j + 2).toLowerCase() == "r" &&
              txt.charAt(j + 3).toLowerCase() == ">"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "<br>",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 3;
            } else if (
              txt.charAt(j) == "&" &&
              txt.charAt(j + 1).toLowerCase() == "n" &&
              txt.charAt(j + 2).toLowerCase() == "b" &&
              txt.charAt(j + 3).toLowerCase() == "s" &&
              txt.charAt(j + 4).toLowerCase() == "p" &&
              txt.charAt(j + 5).toLowerCase() == ";"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "&nbsp;",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 5;
            } else if (txt.charAt(j) == " ") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: " ",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              // j = j + 6;
            } else {
              word += txt.charAt(j);
            }
          }
          if (word != "") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
          }

          array[i].WordsArray = wordsArray;
          array[i].startTransitionWidth = calculateWidthByDuration(
            msToTime(CalculatedTime)
          );

          //check if full width is smaller than transition then make it dynamic

          if (array[i].startTransitionWidth > array[i].widthOnTimeline / 2) {
            let MaxTotalMs = (array[i].widthOnTimeline / 2) * onePxEquivalent;
            let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
            let downSizePercentage = maxPerWordMs / perWordMS;
            let upsizeOpacityIncrement =
              opacityIncrement * (1 - downSizePercentage) + opacityIncrement;
            opacityIncrement = upsizeOpacityIncrement;
            perWordFPS = 60 * (1 - downSizePercentage) + 60;
            perWordTimeout = (1 / opacityIncrement) * perWordFPS;
            perWordMS = maxPerWordMs;
            wordsArray = [];
            cleanWordsArray = [];
            CalculatedTime = 0;

            for (let j = 0; j < txt.length; j++) {
              if (
                txt.charAt(j) == "<" &&
                txt.charAt(j + 1).toLowerCase() == "b" &&
                txt.charAt(j + 2).toLowerCase() == "r" &&
                txt.charAt(j + 3).toLowerCase() == ">"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "<br>",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime +=
                    perWordTimeout - (perWordTimeout - perWordMS);
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 3;
              } else if (
                txt.charAt(j) == "&" &&
                txt.charAt(j + 1).toLowerCase() == "n" &&
                txt.charAt(j + 2).toLowerCase() == "b" &&
                txt.charAt(j + 3).toLowerCase() == "s" &&
                txt.charAt(j + 4).toLowerCase() == "p" &&
                txt.charAt(j + 5).toLowerCase() == ";"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "&nbsp;",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime +=
                    perWordTimeout - (perWordTimeout - perWordMS);
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 5;
              } else if (txt.charAt(j) == " ") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: " ",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime +=
                    perWordTimeout - (perWordTimeout - perWordMS);
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
              } else {
                word += txt.charAt(j);
              }
            }
            if (word != "") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout - (perWordTimeout - perWordMS);
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
            }
          }

          array[i].wordByWordFadeInData = {
            CalculatedTime: CalculatedTime,
            opacityIncrement: opacityIncrement,
            perWordFPS: perWordFPS,
            perWordTimeout: perWordTimeout,
            perWordMS: perWordMS,
            cleanWordsArray: cleanWordsArray,
          };

          array[i].WordsArray = wordsArray;
          array[i].startTransitionWidth = calculateWidthByDuration(
            msToTime(CalculatedTime + perWordMS)
          );
        } else if (types == "animated WordByWordAppear ") {
          var txt = array[i].text;
          let wordsArray = [];
          let cleanWordsArray = [];
          let word = "";
          let CalculatedTime = 0;
          let opacityIncrement = 0.03;
          let perWordFPS = 60;
          let perWordTimeout = (1 / opacityIncrement) * perWordFPS;
          let perWordMS = 2000;

          for (let j = 0; j < txt.length; j++) {
            if (
              txt.charAt(j) == "<" &&
              txt.charAt(j + 1).toLowerCase() == "b" &&
              txt.charAt(j + 2).toLowerCase() == "r" &&
              txt.charAt(j + 3).toLowerCase() == ">"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "<br>",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 3;
            } else if (
              txt.charAt(j) == "&" &&
              txt.charAt(j + 1).toLowerCase() == "n" &&
              txt.charAt(j + 2).toLowerCase() == "b" &&
              txt.charAt(j + 3).toLowerCase() == "s" &&
              txt.charAt(j + 4).toLowerCase() == "p" &&
              txt.charAt(j + 5).toLowerCase() == ";"
            ) {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "&nbsp;",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              j = j + 5;
            } else if (txt.charAt(j) == " ") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: " ",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordTimeout;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
              // j = j + 6;
            } else {
              word += txt.charAt(j);
            }
          }
          if (word != "") {
            let obj = {
              id: `wbwf_${makeid(8)}`,
              word: word,
              next: "",
              startAt: CalculatedTime,
            };
            if (word != "") {
              CalculatedTime += perWordTimeout;
              cleanWordsArray.push(obj);
            }
            wordsArray.push(obj);
            word = "";
          }

          array[i].WordsArray = wordsArray;
          array[i].startTransitionWidth = calculateWidthByDuration(
            msToTime(CalculatedTime)
          );

          //check if full width is smaller than transition then make it dynamic

          if (array[i].startTransitionWidth > array[i].widthOnTimeline / 2) {
            let MaxTotalMs = (array[i].widthOnTimeline / 2) * onePxEquivalent;
            let maxPerWordMs = MaxTotalMs / cleanWordsArray.length;
            let downSizePercentage = maxPerWordMs / perWordMS;
            let upsizeOpacityIncrement =
              opacityIncrement * (1 - downSizePercentage) + opacityIncrement;
            opacityIncrement = upsizeOpacityIncrement;
            perWordFPS = maxPerWordMs / 60; //(60 * (1 - downSizePercentage)) + 60;
            perWordTimeout = (1 / opacityIncrement) * perWordFPS;
            perWordMS = maxPerWordMs;
            wordsArray = [];
            cleanWordsArray = [];
            CalculatedTime = 0;

            for (let j = 0; j < txt.length; j++) {
              if (
                txt.charAt(j) == "<" &&
                txt.charAt(j + 1).toLowerCase() == "b" &&
                txt.charAt(j + 2).toLowerCase() == "r" &&
                txt.charAt(j + 3).toLowerCase() == ">"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "<br>",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime += perWordMS;
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 3;
              } else if (
                txt.charAt(j) == "&" &&
                txt.charAt(j + 1).toLowerCase() == "n" &&
                txt.charAt(j + 2).toLowerCase() == "b" &&
                txt.charAt(j + 3).toLowerCase() == "s" &&
                txt.charAt(j + 4).toLowerCase() == "p" &&
                txt.charAt(j + 5).toLowerCase() == ";"
              ) {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: "&nbsp;",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime += perWordMS;
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
                j = j + 5;
              } else if (txt.charAt(j) == " ") {
                let obj = {
                  id: `wbwf_${makeid(8)}`,
                  word: word,
                  next: " ",
                  startAt: CalculatedTime,
                };
                if (word != "") {
                  CalculatedTime += perWordMS;
                  cleanWordsArray.push(obj);
                }
                wordsArray.push(obj);
                word = "";
              } else {
                word += txt.charAt(j);
              }
            }
            if (word != "") {
              let obj = {
                id: `wbwf_${makeid(8)}`,
                word: word,
                next: "",
                startAt: CalculatedTime,
              };
              if (word != "") {
                CalculatedTime += perWordMS;
                cleanWordsArray.push(obj);
              }
              wordsArray.push(obj);
              word = "";
            }
          }
          let scaleDecriment = 10 / (1 / opacityIncrement);
          array[i].wordByWordFadeInData = {
            CalculatedTime: CalculatedTime,
            opacityIncrement: opacityIncrement,
            perWordFPS: perWordFPS,
            perWordTimeout: perWordTimeout,
            perWordMS: perWordMS,
            cleanWordsArray: cleanWordsArray,
            scaleDecriment: scaleDecriment,
          };
          array[i].WordsArray = wordsArray;
          array[i].startTransitionWidth = calculateWidthByDuration(
            msToTime(CalculatedTime + perWordMS)
          );
        }

        if (text.offsetWidth < inputRef.current.offsetWidth) {
          array[i].width = inputRef.current.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
        }
        if (text.offsetHeight < inputRef.current.offsetHeight) {
          array[i].height = inputRef.current.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
        }
      }
    }
    setLayersData(array);
  };

  useEffect(() => {
    window.setTimeout(function () {
      var sel, range;
      if (window.getSelection && document.createRange) {
        range = document.createRange();
        range.selectNodeContents(inputRef.current);
        sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(inputRef.current);
        range.select();
      }
    }, 1);
  }, [inputRef]);

  // useEffect(() => {
  //   if (value.Editable)
  //     var element = document.getElementsByClassName('jzmUzU')
  //   for (let SubElement of element) {
  //     if (SubElement.firstChild) {
  //       SubElement.style.zIndex = 999999
  //       SubElement.classList.add("RectBorder");
  //     } else {
  //       SubElement.style.zIndex = 99999
  //       SubElement.classList.remove("RectBorder");
  //     }
  //   }
  // }, [value.Editable])

  const pasteWithoutFormating = (e) => {
    e.preventDefault();

    // get text representation of clipboard
    var text = (e.originalEvent || e).clipboardData.getData("text/plain");

    // insert text manually
    document.execCommand("insertHTML", false, text);
  };

  return (
    <span
      tabIndex="1"
      editing="true"
      id={"Text-" + value.AnimationId}
      textkey={value.key}
      ref={inputRef}
      spellCheck="false"
      contentEditable="true"
      style={{
        textDecoration: value.textDec,
        fontStyle: value.Fontstyle,
        fontSize: Math.round((value.fontSize * EditorZoom) / 100) + "px",
        fontWeight: value.fontWeight,
        opacity: value.opacity,
        color: value.textColor,
        overflowWrap: "break-word",
        fontFamily: value.googleFontSetting.fontName,
        scale: value.scale,
        transformOrigin: `top left`,
        width: (value.width * EditorZoom) / 100,
        lineHeight: value.LineHeight,
        letterSpacing: value.LetterSpacing + "em",
        // maxWidth: value.width,
        // transform: !CanvasDisplay ? ` rotate(${value.rotateAngle}deg)` : "",
        transform: value.flip
          ? value.flip +
            (!CanvasDisplay ? ` rotate(${value.rotateAngle}deg)` : "")
          : !CanvasDisplay
          ? ` rotate(${value.rotateAngle}deg)`
          : "",
      }}
      onBlur={() => {
        updateText();
      }}
      onFocus={() => setisTextInputOrAreaFocus(true)}
      className="textInput textEditStart"
      suppressContentEditableWarning={true}
      dangerouslySetInnerHTML={{ __html: value.text }}
      onPaste={(event) => pasteWithoutFormating(event)}
    />
  );
};
export default EditableText;
